var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        {
            'open': _vm.accordionOpen,
        },
        'accordion-item',
    ]},[_c('button',{ref:_vm.id,staticClass:"accordion-header d-block",on:{"click":_vm.toggleAccordion}},[_c('h3',{staticClass:"accordion-title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.subtitle)?_c('span',{staticClass:"accordion-subtitle hidden-until-md"},[_vm._v("\n                "+_vm._s(_vm.subtitle)+"\n            ")]):_vm._e(),_vm._v(" "),_c('icon',{attrs:{"icon":"arrow-right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"accordion-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }